import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * `cn` for the v2 components (redesign phase 5, #455).
 *
 * The shared `lib/tailwind.ts` uses a stock `twMerge`, which does not know the
 * type-scale utilities from tailwind-theme.css. It reads `text-label` as a
 * text COLOUR, so `cn("text-label", "text-ink")` silently drops the size.
 * Registering the scale as font sizes keeps both. At implementation this
 * config moves into `lib/tailwind.ts`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["heading-lg", "heading-md", "heading-sm", "label", "body", "body-long", "caption", "overline", "micro"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
